// store/paymentHistoryCxp.slice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PaymentHistoryCxpState {
  /**
   * 📌 Historial actual cargado
   */
  history: any | null;

  /**
   * 🆔 ID seleccionado
   */
  selectedPayableId: number | null;

  /**
   * 🔄 loading general
   */
  loading: boolean;

  /**
   * ❌ error global
   */
  error: string | null;
}

const initialState: PaymentHistoryCxpState = {
  history: null,

  selectedPayableId: null,

  loading: false,
  error: null,
};

const paymentHistoryCxpSlice = createSlice({
  name: "paymentHistoryCxp",
  initialState,

  reducers: {
    /**
     * 🔄 loading
     */
    setPaymentHistoryLoading(
      state,
      action: PayloadAction<boolean>
    ) {
      state.loading = action.payload;
    },

    /**
     * ❌ error
     */
    setPaymentHistoryError(
      state,
      action: PayloadAction<string | null>
    ) {
      state.error = action.payload;
    },

    /**
     * 📌 set history
     */
    setPaymentHistory(
      state,
      action: PayloadAction<any>
    ) {
      state.history = action.payload;
      state.loading = false;
    },

    /**
     * 🆔 guardar Payable actual
     */
    setSelectedPayableId(
      state,
      action: PayloadAction<number>
    ) {
      state.selectedPayableId =
        action.payload;
    },

    /**
     * 🧹 limpiar state completo
     */
    clearPaymentHistory(state) {
      state.history = null;
      state.selectedPayableId = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setPaymentHistoryLoading,
  setPaymentHistoryError,
  setPaymentHistory,
  setSelectedPayableId,
  clearPaymentHistory,
} = paymentHistoryCxpSlice.actions;

export default paymentHistoryCxpSlice.reducer;